var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap justify-center space-x-2"},[_c('span',{staticClass:"px-4 py-2 rounded-full ayadi-900 bg-gray-200 font-semibold text-sm flex align-center w-max transition duration-300 ease"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }